import { render, staticRenderFns } from "./FileInfoDlg.vue?vue&type=template&id=16169ea0"
import script from "./FileInfoDlg.vue?vue&type=script&lang=js"
export * from "./FileInfoDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports